import React from 'react';

import { connect, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { IconShareScreen, IconUnshare } from '../IconSet';
import ToolbarButton from './ToolbarButton';
import useStyles from './buttonsStyle';
import messages from './buttonsMessages';

import { ScreenSharingOptions } from '../../lib/redux_types';
import { shareScreen, stopScreenSharing } from '../../lib/actions/room';
import { iconColors as colors } from '../../colors';

import { State } from '../../lib/reducers';
import classNames from 'classnames';


function ShareScreen({ isSharingScreen, isRequestingScreen, constraints }: ExtendedProps) {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const shareOrUnshare = React.useCallback(
    () => {
      if (isSharingScreen) {
        dispatch(stopScreenSharing());
      }
      else {
        if (constraints) {
          dispatch(shareScreen(constraints));
        }
        else {
          dispatch(shareScreen());
        }
      }
    }
    , [dispatch, isSharingScreen, constraints]
  );
  const label = isSharingScreen ? formatMessage(messages.unShareScreen) : formatMessage(messages.shareScreen);
  const selected = isSharingScreen ? classes.buttonsSelected : null;
  const cls = classNames(classes.buttons, selected);

  return (
    <ToolbarButton
      icon={isSharingScreen ? <IconUnshare size={28} color={colors.contrast} /> : <IconShareScreen size={28} />}
      text={label}
      buttonProps={isRequestingScreen ? { className: cls } : { className: cls, onClick: shareOrUnshare }}


    />
  );
}


type MappedProps = {
  isRequestingScreen: boolean;
  isSharingScreen: boolean;
}


type ExtendedProps = {
  constraints?: ScreenSharingOptions;
} & MappedProps;


const mapStateToProps = (state: State): MappedProps => {
  return {
    isSharingScreen: Boolean(state.room.screenStream),
    isRequestingScreen: state.room.isRequestingScreen,
  };
};


export default connect(mapStateToProps)(ShareScreen);
